var App = App || {};

App.WidgetCommunity = (function ($) {
    'use strict';

    function Init(selector) {

        if (selector.length) {
            ImagesCarousels(selector);
            HeadingsCarousel(selector);
        }
    }

    function ImagesCarousels(selector) {

        let splides = [];
        const toggle = selector.find(".widget-community-images .splide__controls button");
        const carousels = selector.find(".widget-community-image-group .splide");
        const options = {
            type: 'loop',
            speed: 500,
            arrows: false,
            pagination: false,
            direction: 'ttb',
            height: '550px',
            perPage: 2.5,
            gap: '2rem',
            focus: 'center',
            //mediaQuery: 'min',
            breakpoints: {
                767: {
                    direction: 'ltr',
                    height: '190px',
                    perPage: 2.5
                },
                500: {
                    perPage: 1.5
                }
            }
        }

        carousels.toArray().forEach((carousel, index) => {

            const optionsRev = index == 0
                ? {
                    ...options, autoScroll: {
                        pauseOnHover: true,
                        speed: -0.2,
                    }
                }
                : {
                    ...options, autoScroll: {
                        pauseOnHover: true,
                        speed: 0.2,
                    }
                };

            const splide = new Splide(carousel, optionsRev);
            splide.mount(window.splide.Extensions);
            splides.push(splide);

            carousel.setAttribute('aria-hidden', 'true');
            carousel.setAttribute('role', 'presentation');
        });

        toggle.addClass("is-active").on("click", function () {
            splides.forEach((splide) => {
                if (splide.Components.AutoScroll.isPaused()) {
                    splide.Components.AutoScroll.play();
                    toggle.addClass("is-active")
                }
                else {
                    splide.Components.AutoScroll.pause();
                    toggle.removeClass("is-active")
                }
            });
        });
    }

    function HeadingsCarousel(selector) {

        const carousel = selector.find(".widget-community-headlines .splide");
        const slides = carousel.find(".splide__slide");
        const options = {
            type: 'loop',
            speed: 500,
            arrows: true,
            pagination: false,
            direction: 'ttb',
            height: '1.25em',
            autoplay: true,
            interval: 2000,
            keyboard: false
        }

        if (slides.length > 1) {
            const splide = new Splide(carousel[0], options);
            splide.mount({});
        }
    }

    return {
        Init: Init
    };

})(jQuery);